var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 14,
    viewBox: "0 0 119 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_46_18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.324 0.518921H0.899902V12.7567H118.324V0.518921Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.76611 6.21546L114.452 6.21545",
    stroke: "white",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.869 1.14917V13.0872",
    stroke: "white",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51611 1.14917V13.0872",
    stroke: "white",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.61377 6.36816L115.42 6.36815",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.837 1.52258V11.3226",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.36377 1.52258V11.3226",
    stroke: "black",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_46_18"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 118,
    height: 14,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrowDown.6175f536f575d5e445d1163a6ffada13.svg";
export { ForwardRef as ReactComponent };